(() => {
  if (customElements.get('menu-toggle')) {
    return;
  }

  class MenuToggle extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', this.toggle.bind(this));
    }

    toggle() {
      if(this.hasAttribute('open')) {
        this.removeAttribute('open');
      } else {
        document.querySelector('menu-toggle[open]')?.removeAttribute('open');
        this.setAttribute('open', '');
      }
    }
  }

  customElements.define('menu-toggle', MenuToggle);
})();